// Detects whether a string already looks like the rich-text HTML produced
// by the in-app editor (as opposed to a legacy plain-text capture created
// before the rich text editor existed).
const RICH_TAG_PATTERN = /<(p|ol|ul|li|strong|em|u|br|span)\b/i;

// Converts a legacy plain-text capture (raw string, possibly multi-line,
// never HTML) into a safe HTML fragment so it can be loaded into the rich
// text editor or rendered with dangerouslySetInnerHTML without breaking.
// No-op if the text already contains rich-text tags.
export function toDisplayHtml(text) {
  if (!text) return "";
  if (RICH_TAG_PATTERN.test(text)) return text;
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return `<p>${escaped.replace(/\n/g, "<br/>")}</p>`;
}

// Derives a default title for a text note from its content - strips HTML
// tags, decodes HTML entities (e.g. "&nbsp;" from the rich text editor),
// collapses whitespace/line-breaks into single spaces, and takes the first
// ~20 characters. Used while the user is typing a new text note that hasn't
// been given a manual title yet.
export function deriveTitleFromHtml(html) {
  if (!html) return "";
  // Parse with the DOM instead of a tag-stripping regex so entities like
  // "&nbsp;" are decoded to real whitespace instead of leaking into the
  // title as literal "&nbsp;" text.
  const container = document.createElement("div");
  container.innerHTML = html;
  const plain = (container.textContent || "").replace(/\s+/g, " ").trim();
  return plain.slice(0, 20);
}
